var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLogSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52575C",
    fillRule: "evenodd",
    d: "M17.377 2.375c-2.07-1.155-4.455-1.6-6.798-1.268C8.052 1.467 5.363 2.71 3 5.585V2c0-.552-.448-1-1-1s-1 .448-1 1v6c0 .552.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1H4.427c2.085-2.608 4.378-3.62 6.434-3.912 1.908-.272 3.853.09 5.54 1.033 1.689.943 3.03 2.415 3.82 4.197.79 1.783.986 3.776.557 5.681-.43 1.905-1.46 3.615-2.933 4.875-1.473 1.259-3.31 2-5.235 2.111-1.924.112-3.833-.41-5.439-1.49-1.606-1.08-2.823-2.66-3.466-4.501-.182-.522-.752-.797-1.273-.615-.522.182-.797.752-.615 1.273.784 2.248 2.27 4.18 4.238 5.502 1.968 1.323 4.31 1.965 6.671 1.828 2.362-.137 4.614-1.046 6.418-2.588 1.804-1.541 3.061-3.632 3.585-5.955.523-2.324.285-4.756-.68-6.931-.964-2.176-2.603-3.978-4.672-5.133z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#52575C",
    fillRule: "evenodd",
    d: "M12 7c.552 0 1 .448 1 1v3.586l2.707 2.707c.39.39.39 1.024 0 1.414-.39.39-1.024.39-1.414 0l-3-3C11.105 12.52 11 12.265 11 12V8c0-.552.448-1 1-1z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogSvg);
export default __webpack_public_path__ + "static/media/activityLogSvg.f4e6ff3411eee118cae633ba8f794d04.svg";
export { ForwardRef as ReactComponent };